import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import * as CompanyIconActions from './company-icon.actions';

export const companyIconFeatureKey = 'company-icon';

export interface State extends EntityState<null> {
  // additional entities state properties
  iconUrl: string;
  loading: boolean;
  creating: boolean;
  updating: boolean;
  deleting: boolean;
  error: any;
}

export const adapter: EntityAdapter<null> = createEntityAdapter<null>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  iconUrl: null,
  loading: false,
  creating: false,
  updating: false,
  deleting: false,
  error: null,
});

export const companyIconReducer = createReducer(
  initialState,
  on(CompanyIconActions.loadCompanyIcon, (state) => ({ ...state, loading: true })),
  on(CompanyIconActions.loadCompanyIconSuccess, (state, action) => ({ ...state, iconUrl: action.url, loading: false })),
  on(CompanyIconActions.loadCompanyIconFailure, (state, action) => ({ ...state, error: action.error, loading: false })),
  on(CompanyIconActions.updateCompanyIcon, (state, action) => ({ action, ...state, updating: true })),
  on(CompanyIconActions.updateCompanyIconSuccess, (state, action) => ({
    ...state,
    iconUrl: action.url,
    updating: false,
  })),
  on(CompanyIconActions.updateCompanyIconFailure, (state, action) => ({
    ...state,
    error: action.error,
    updating: false,
  })),
  on(CompanyIconActions.deleteCompanyIcon, (state, action) => ({ action, ...state, deleting: true })),
  on(CompanyIconActions.deleteCompanyIconSuccess, (state, action) => ({
    ...state,
    iconUrl: null,
    deleting: false,
  })),
  on(CompanyIconActions.deleteCompanyIconFailure, (state, action) => ({
    ...state,
    error: action.error,
    deleting: false,
  })),
  on(CompanyIconActions.clearCompanyIcon, (state) => adapter.removeAll(state))
);

export const selectCompanyIconState = createFeatureSelector<State>(companyIconFeatureKey);
export const selectCompanyIconUrl = createSelector(selectCompanyIconState, (state) => state.iconUrl);
export const selectCompanyIconLoading = createSelector(selectCompanyIconState, (state) => state.loading);
